import React, { useEffect, useState } from "react";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../tools/api_Routes";
import {
  Button,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableSortLabel,
  TableRow,
} from "@mui/material";
import DeleteModal from "./DeleteModal";
import { useDispatch } from "react-redux";
import { setOpen } from "../../Redux/ModalReducer";
import DataTable from "./data-table";
import { AddButton } from "../Button/AddButton";
import jsPDF from "jspdf";
import {Can} from "../Can"; // Import jsPDF

const OffersTable = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [RefreshData, setRefreshData] = useState(true);
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [verifyModalShow, setVerifyModalShow] = useState(false);
  const [selectedVerifyId, setSelectedVerifyId] = useState(null);
  const [orderBy, setOrderBy] = useState("id");
  const [orderDirection, setOrderDirection] = useState("asc");

  const handleShow = (id) => {
    setSelectedId(id);
    setShow(true);
    dispatch(setOpen(true));
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };

  const getData = async () => {
    setIsLoading(true);
    const { response, message } = await Helper.Get({
      url: api_Routes.Offers.View,
      hasToken: true,
    });
    if (response) {
      setData(response.data);
    }
    setIsLoading(false);
  };

  const handleSort = (column) => {
    const isAsc = orderBy === column && orderDirection === "asc";
    setOrderBy(column);
    setOrderDirection(isAsc ? "desc" : "asc");
  };

  const sortedData = data.sort((a, b) => {
    if (orderDirection === "asc") {
      return a[orderBy] > b[orderBy] ? 1 : -1;
    }
    return a[orderBy] < b[orderBy] ? 1 : -1;
  });
  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.text("Offers Table", 14, 10);

    // Table columns
    const columns = [
      "ID",
      "Title",
      "Note",
      "Total price",
      "Discount",
      "Final Price",
      "Active"

    ];

    // Table rows
    const rows = sortedData.map((item) => [
      item.offer_id,
      item.title,
      item.note,
      item.total_price,
      item.discount,
      item.final_price,
      item.active ? "Yes" : "No",
      new Date(item.created_at).toLocaleDateString(),
    ]);

    // Add table to PDF
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 20,
    });

    // Save the PDF
    doc.save("offer.pdf");
  };

  useEffect(() => {
    if (RefreshData) {
      getData();
      setRefreshData(false);
    }
  }, [RefreshData]);

  return isLoading ? (
    <LinearProgress />
  ) : (
    <>
      <Can I="store" a="offers">
      <div className="flex flex-col-reverse justify-end items-center gap-4 mb-3 md:flex-row">
        <AddButton to="/Add-Offer" label="Add Offer" />
      </div>
      </Can>
      {/*<Button*/}
      {/*  variant="contained"*/}
      {/*  color="primary"*/}
      {/*  onClick={handleExportPDF}*/}
      {/*  style={{ marginBottom: "16px" }}*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</Button>*/}
      <TableContainer component={Paper}>
        {sortedData?.length > 0 ? (
          <Table aria-label="collapsible table">
            <TableHead>

              <TableRow>
                <TableCell align="center" sx={{ backgroundColor: "primary.main", color: "white", fontWeight: "bold" }} />

                {[{ label: "ID", key: "offer_id" }, { label: "Title", key: "title" }, { label: "Note", key: "note" }, { label: "Total price", key: "total_price" }, { label: "Discount", key: "discount" }, { label: "Final Price", key: "final_price" }, { label: "active", key: "active" }, { label: "Actions", key: null }].map((column, idx) => (

                  <TableCell
                    key={idx}
                    align="center"
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {column.key ? (
                      <TableSortLabel
                        active={orderBy === column.key}
                        direction={orderBy === column.key ? orderDirection : "asc"}
                        onClick={() => handleSort(column.key)}
                      >
                        {column.label}
                      </TableSortLabel>
                    ) : (
                      column.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData?.map((item, idx) => (
                <DataTable key={idx} data={item} handleShow={handleShow} />
              ))}
            </TableBody>
          </Table>
        ) : (
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  There are no data yet
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        )}
      </TableContainer>
      <DeleteModal
        show={show}
        handleClose={handleClose}
        selectedId={selectedId}
        setShouldRefresh={setRefreshData}
      />
    </>
  );
};

export default OffersTable;
